export default __webpack_public_path__ + "static/media/Photo.cd5a580c.png";